export default "__VITE_ASSET__vbfY3Efd__"